import { saveAs } from 'file-saver';
import { v4 as uuidv4 } from 'uuid';

let _comments = [];


export function ParseCommentsData(files, readyCallback = null)
{
	const reader = new FileReader();
	reader.readAsText(files[0], 'UTF-8');
	reader.onload = function({ target }) {
		_comments = JSON.parse(target.result);
		if (readyCallback) 
		{
			readyCallback();
		}
    };
}

export function GetComments()
{
	return _comments;
}

// Replaces everything at once: a model opened from the account brings its own
// notes, and the ones from the model before it must not stay on screen.
export function SetComments(comments)
{
	_comments = Array.isArray(comments) ? comments.slice() : [];
}

export function ClearComments()
{
	_comments = [];
}

export function RemoveComment(uid)
{
	let index = _comments.findIndex((comment) => comment.uid === uid);
	if (index < 0)
	{
		return false;
	}
	_comments.splice(index, 1);
	return true;
}

export function GetCommentsForNode(nodeName)
{
	let result = [];
	for (let i = 0; i < _comments.length; i++) 
	{
		if (_comments[i].nodeName === nodeName) 
		{
			result.push(_comments[i]);
		}
	}
	return result;
}

export function AddComment(name, text, nodeName, author = '',  dx = 0, dy = 0, dz = 0, onAddedCallback = null)
{
	let comment = {
		'uid':uuidv4(),
		'nodeName':nodeName,
		'name':name,
		'text':text,
		'coordinates':{'x':dx, 'y':dy, 'z':dz},
		'author':author,
		'time':Date.now()
	};
	_comments.push(comment);
	
	if (onAddedCallback)
	{
		onAddedCallback();
	}
	return comment;
}

export function DownloadComments()
{
	let fileName = 'comments.json';
	let fileToSave = new Blob([JSON.stringify(_comments, undefined, 2)], {
		type: 'application/json'
	});
	saveAs(fileToSave, fileName);
}